import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Home from '@/views/Home'
import Admin from '@/views/Admin'
import Evento from '@/views/Evento'
//import Registro from '@/views/Registro'
import Seguimiento from '@/views/Seguimiento'
import Asistencia from '@/views/Asistencia'
import Beneficiarios from '@/views/Beneficiarios'

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home/:evento_id?/:servicio_id?/:persona_id?',
      name: 'Home',
      props: true,
      component: Home
    },
    {
      path: '/eventos',
      name: 'Eventos',
      component: Admin
    },
    {
      path: '/eventos/:evento_id/personas',
      name: 'personas_eventos',
      component: Beneficiarios,
      props: true
    },
    {
      path: '/evento',
      name: 'Evento',
      component: Evento
    },
    {
      path: '/registro',
      name: 'asistencia',
      component: Asistencia
    },
    {
      path: '/seguimiento',
      name: 'Seguimiento',
      component: Seguimiento
    },
  ]
});

// let existToken = () => {
//   return !!localStorage.token;
// } 

router.beforeEach((to, from, next)=>{
  // if(to.path != '/login' && !existToken()){
  //   next('/login');
  // } else if (to.path == '/login' && existToken()) {
  //   next('/home');
  // } else if ((to.path == '/login' && !existToken()) || (to.path != '/login' && existToken())) {
  //   next();
  // }
  next();
});

export default router;
